// packages/spheres/src/helpers/getSphereUseCases.ts

import { Schema, UseCaseRow } from 'types/schema';

/**
 * Returns the list of UseCaseRow objects that are “assigned” to this sphere.
 *
 * @param schemaObject  The full Sphere schema object (already fetched from store/DB).
 *                      It should contain a `use_case_tags: string[]` field.
 * @param allUseCases   Flat array of all available use cases (global + org-scoped),
 *                      as returned by getUseCaseTree or similar.
 * @returns             Subset of `allUseCases` whose `system_name` matches one of
 *                      the values in `schemaObject.use_case_tags`.
 */
export function getSphereUseCases(
  schemaObject: Schema,
  allUseCases: UseCaseRow[]
): UseCaseRow[] {
  // 1. Extract assigned use case system_name values from the sphere schema
  const assignedSystemNames: string[] = Array.isArray(schemaObject.use_case_tags)
    ? schemaObject.use_case_tags
    : [];

  if (assignedSystemNames.length === 0) {
    return [];
  }

  // 2. Build a lookup set for faster membership checks
  const nameSet = new Set<string>(assignedSystemNames);

  // 3. Filter the full list of use cases down to only those whose system_name is assigned
  const filtered = allUseCases.filter((uc) => nameSet.has(uc.system_name));

  // 4. Return in the same order as `allUseCases` (which is presumed sorted by category → label)
  return filtered;
}
